import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLock, faHome, faArrowRight, faShieldAlt } from '@fortawesome/free-solid-svg-icons';

const Forbidden = ({ message }) => {
  const navigate = useNavigate();

  return (
    <div className="forbidden-page">
      <div className="background-shapes">
        <div className="shape shape-1"></div>
        <div className="shape shape-2"></div>
        <div className="shape shape-3"></div>
      </div>

      <motion.div
        className="forbidden-container"
        initial={{ opacity: 0, scale: 0.9 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.5 }}
      >
        <div className="icon-wrapper">
          <motion.div
            className="lock-icon-bg"
            animate={{
              boxShadow: ['0 0 0 0px rgba(99, 102, 241, 0.2)', '0 0 0 20px rgba(99, 102, 241, 0)'],
            }}
            transition={{ duration: 2, repeat: Infinity }}
          >
            <FontAwesomeIcon icon={faShieldAlt} className="main-icon" />
          </motion.div>
          <div className="status-badge">403</div>
        </div>

        <motion.div
          className="text-content"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.2 }}
        >
          <h1>غير مصرح بالوصول</h1>
          <p className="description">
            {message || 'عذراً، انت لا تملك الصلاحيات الكافية للوصول إلى هذه الصفحة. يرجى التأكد من تسجيل الدخول بالحساب الصحيح أو التواصل مع الإدارة.'}
          </p>
        </motion.div>

        <motion.div
          className="actions"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.3 }}
        >
          <button
            className="btn btn-primary"
            onClick={() => navigate('/')}
          >
            <FontAwesomeIcon icon={faHome} />
            <span>الرئيسية</span>
          </button>
        </motion.div>
      </motion.div>

      <style jsx>{`
        .forbidden-page {
            min-height: 100vh;
            display: flex;
            align-items: center;
            justify-content: center;
            background: linear-gradient(135deg, #F8FAFC 0%, #EFF6FF 100%);
              font-family: "Zain", sans-serif;
            position: relative;
            overflow: hidden;
            direction: rtl;
        }

        .background-shapes {
            position: absolute;
            width: 100%;
            height: 100%;
            overflow: hidden;
            z-index: 0;
        }

        .shape {
            position: absolute;
            border-radius: 50%;
            filter: blur(80px);
            opacity: 0.6;
        }

        .shape-1 {
            width: 400px;
            height: 400px;
            background: #E0E7FF;
            top: -100px;
            right: -100px;
        }

        .shape-2 {
            width: 300px;
            height: 300px;
            background: #F3E8FF;
            bottom: -50px;
            left: -50px;
        }

        .shape-3 {
            width: 200px;
            height: 200px;
            background: #DBEAFE;
            top: 40%;
            left: 50%;
            transform: translate(-50%, -50%);
        }

        .forbidden-container {
            position: relative;
            z-index: 1;
            background: rgba(255, 255, 255, 0.8);
            backdrop-filter: blur(20px);
            padding: 60px 40px;
            border-radius: 30px;
            box-shadow: 0 20px 40px rgba(0, 0, 0, 0.05);
            text-align: center;
            max-width: 500px;
            width: 90%;
            border: 1px solid rgba(255, 255, 255, 1);
        }

        .icon-wrapper {
            position: relative;
            width: 120px;
            height: 120px;
            margin: 0 auto 30px;
        }

        .lock-icon-bg {
            width: 100%;
            height: 100%;
            background: linear-gradient(135deg, #6366F1 0%, #4F46E5 100%);
            border-radius: 50%;
            display: flex;
            align-items: center;
            justify-content: center;
            color: white;
            font-size: 3rem;
            box-shadow: 0 10px 20px rgba(79, 70, 229, 0.3);
        }

        .status-badge {
            position: absolute;
            bottom: 0;
            right: 0;
            background: #EF4444;
            color: white;
            font-weight: 800;
            padding: 5px 12px;
            border-radius: 20px;
            border: 4px solid white;
            box-shadow: 0 4px 6px rgba(0,0,0,0.1);
        }

        .text-content h1 {
            color: #1E293B;
            font-size: 2rem;
            font-weight: 800;
            margin-bottom: 15px;
        }

        .description {
            color: #64748B;
            line-height: 1.6;
            margin-bottom: 30px;
            font-size: 1.1rem;
        }

        .actions {
            display: flex;
            gap: 15px;
            justify-content: center;
        }

        .btn {
            border: none;
            padding: 12px 24px;
            border-radius: 12px;
            font-family: inherit;
            font-weight: 700;
            cursor: pointer;
            display: flex;
            align-items: center;
            gap: 8px;
            transition: all 0.2s;
            font-size: 1rem;
        }

        .btn-primary {
            background: #4F46E5;
            color: white;
        }

        .btn-primary:hover {
            background: #4338CA;
            transform: translateY(-2px);
            box-shadow: 0 10px 20px rgba(79, 70, 229, 0.2);
        }

        .btn-secondary {
            background: #F1F5F9;
            color: #475569;
        }

        .btn-secondary:hover {
            background: #E2E8F0;
            transform: translateY(-2px);
        }

        @media (max-width: 480px) {
            .forbidden-container {
                padding: 40px 20px;
            }
            
            .text-content h1 {
                font-size: 1.5rem;
            }

            .actions {
                flex-direction: column;
            }

            .btn {
                width: 100%;
                justify-content: center;
            }
        }
      `}</style>
    </div>
  );
};

export default Forbidden;